// 全身のメーカーのスマホのパーツ一覧（2 段で左右にスクロール）の、続きがある側の矢印（2026-10-28 ユーザー「左右にスクロールできると分かるように」）。
//   続きがある側だけ出す。指でさわってから少しのあいだ（スクロール中も）は消し、止まって少ししたら出す。押すと見えている列の分だけ送る。
//   見た目の合図なので読み上げ・キーボードの順番には入れない（パーツはそのまま選べる）。PC・ほかのメーカー（縦のスクロール）では作らない
import { anim, tallUI } from './store.js';
import { $ } from './util.js';

const IDLE = 1500; // さわってから矢印をまた出すまで
const COL = 67 + 8; // 1 列（タイル 67px と間 8px。style.css の .app.tall .grid）

export function bindPartsNav() {
  if (!tallUI) return;
  const box = $('parts');
  let timer = 0, busy = false;
  const update = () => {
    const max = box.scrollWidth - box.clientWidth;
    prev.classList.toggle('on', !busy && box.scrollLeft > 4);
    next.classList.toggle('on', !busy && box.scrollLeft < max - 4);
  };
  const touched = () => {
    busy = true;
    update();
    clearTimeout(timer);
    timer = window.setTimeout(() => { busy = false; update(); }, IDLE);
  };
  const make = (dir: number) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'parts-nav ' + (dir < 0 ? 'prev' : 'next');
    b.tabIndex = -1;
    b.setAttribute('aria-hidden', 'true');
    b.innerHTML = '<svg viewBox="0 0 24 24"><path d="' + (dir < 0 ? 'M14.5 5.5 8 12l6.5 6.5' : 'M9.5 5.5 16 12l-6.5 6.5') + '"/></svg>';
    b.addEventListener('click', () => {
      const step = Math.max(1, Math.floor((box.clientWidth - 24) / COL) - 1) * COL; // 1 列は残して送る（どこから続くか分かるように）
      box.scrollBy({ left: dir * step, behavior: anim ? 'smooth' : 'auto' });
    });
    box.after(b);
    return b;
  };
  const prev = make(-1), next = make(1);
  // 指でさわったときだけ消す（カテゴリを開いたときに選んでいるパーツまで送るのは、さわったことにしない）
  box.addEventListener('pointerdown', touched, { passive: true });
  box.addEventListener('wheel', touched, { passive: true });
  box.addEventListener('scroll', () => { if (busy) touched(); else update(); }, { passive: true });
  new MutationObserver(update).observe(box, { childList: true }); // カテゴリを変えた
  new ResizeObserver(update).observe(box);
  update();
}
